<div class="header-title"> 
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
            <a routerLink="/button" aria-label="back" class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button"> 
                <span class="u-icon icon-chevron-left"></span>
                <span class="u-button-text">Back</span>
            </a>
        </div>
        <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
            <h1 class="font-semibold u-ma-0 flex header-title--name"> Navigation (English)</h1>
        </div>
    </div>

    <div class="c-header__gradient"></div>
</div>
<ul class="c-list u-list-style-none u-display-block">
    <li class="active collapse c-list-item">
        <a routerLink="/global-navigation-spanish" class="c-list__link u-button">
            GOTO Global Navigation (Spanish)
        </a>
    </li>
    <li class="active collapse c-list-item">
        <a routerLink="/global-navigation-hindi" class="c-list__link u-button">
            GOTO Global Navigation (Hindi)
        </a>
    </li>
</ul>
<maced-global-navigation id="globalNavigationId" [menuToggleStateLabel]="menuToggleStateLabelEnglish" styleClass="testClass" [menuList]="menuList" [isOpened]="menuExpandCollapse" [currentRoute]="currentRoute"></maced-global-navigation>